module.exports = __webpack_public_path__ + "assets/img/SG_005.acf76884.jpg";